export const WebEvent = {
    webSocket: null,

    available: () => {
        return "WebSocket" in window;
    },

    connect: () => {
        if (!WebEvent.available()) return false;
        
        const url = process.env.VUE_APP_WS_HOST_ENDPOINT;
        //var wss = window.location.protocol == "https:" ? "wss://" : "ws://";
        WebEvent.webSocket = new WebSocket(url);

        WebEvent.webSocket.onopen = () =>
        {
            console.log("webEvent onOpen.");
            if (WebEvent.onConnect) WebEvent.onConnect();
        };

        WebEvent.webSocket.onmessage = ( evt ) =>
        {
            console.log("webEvent onMessage.");
            var msg = evt.data;
            var parsedEvent = WebEvent.parseEvent(msg);
            if (parsedEvent.method == "NOTIFY") {
                WebEvent.onNotify(parsedEvent);
            }
        };

        WebEvent.webSocket.onclose = () => {
            if (WebEvent.onDisconnect) WebEvent.onDisconnect();
            WebEvent.webSocket = null;
        };

        WebEvent.webSocket.onerror = () =>
        {
            console.log("webEvent onError.");
            if (WebEvent.onError) WebEvent.onError();
        };

        return true;
    },

    disconnect: () => {
        if (WebEvent.webSocket) {
            WebEvent.webSocket.close();
            WebEvent.webSocket = null;
        }
    },

    subscribe: (subject) => {
        if (WebEvent.webSocket) {
            var msg = "SUBSCRIBE " + subject + " WebEvent/1.0";
            WebEvent.webSocket.send(msg);
        }
    },

    unsubscribe: (subject) => {
        if (WebEvent.webSocket) {
            var msg = "UNSUBSCRIBE " + subject + " WebEvent/1.0";
            WebEvent.webSocket.send(msg);
        }
    },

    notify: (subject, data) => {
        if (WebEvent.webSocket) {
            var msg = "NOTIFY " + subject + " WebEvent/1.0\r\n" + data;
            WebEvent.webSocket.send(msg);
        }
    },

    onConnect: () => {},

    onDisconnect: () => {},

    onError: () => {},

    onNotify: () => {},

    parseEvent: (msg) => {
        var event = {};
        var i = 0;
        var methodStart = i;
        while (i < msg.length && msg[i] != " " && msg[i] != "\r" && msg[i] != "\n") i++;
        event.method = msg.substring(methodStart, i);
        while (i < msg.length && msg[i] == " ") i++;
        var subjectStart = i;
        while (i < msg.length && msg[i] != " " && msg[i] != "\r" && msg[i] != "\n") i++;
        event.subject = msg.substring(subjectStart, i);
        while (i < msg.length && msg[i] == " ") i++;
        var versionStart = i;
        while (i < msg.length && msg[i] != " " && msg[i] != "\r" && msg[i] != "\n") i++;
        event.version = msg.substring(versionStart, i);
        while (i < msg.length && (msg[i] == "\r" || msg[i] == "\n")) i++;
        event.data = msg.substring(i);
        return event;
    },
};
